import React from 'react';
import '../css/Header.css';

function Header() {
  return (
    <header className="header">
      <div className="header-container">
        <a href="https://devika.xchip.in" className="header-website-link">
          devika.xchip.in
        </a>
      </div>
    </header>
  );
}

export default Header;
